import { AppState } from 'common/models/AppState';
import { OrgAccess } from 'common/api/models/OrgAccess';
import { UserPermissions } from 'common/api/models/UserPermissions';
import { Member } from 'common/api/models/Member';

export function getAdminAccesses() {
  return {
    NONE: 'None',
    STAFF: 'Staff',
    MEMBERSHIP: 'Membership',
    MEMBERSHIP_PLUS: 'Membership Plus',
    PROFESSIONAL: 'Professional Development',
    CHAPTERS: 'Chapters',
    ACCOUNTING: 'Accounting',
    ADMIN: 'Admin',
    SUPERUSER: 'Superuser',
    CHAPTERSADMIN: 'Chapters Admin',
  };
}

export function toAdminAccessLabel(adminAccess: Member.AdminAccess) {
  const map = getAdminAccesses();
  return map[<any>adminAccess] ? map[<any>adminAccess] : 'None';
}

/**
 * Returns whether the currently logged in user has a given permission type
 * @param appState app state
 * @param perm permission type
 */
export function hasPermission(appState: AppState, perm: UserPermissions.Permissions) {
  return appState.permissions.indexOf(perm) > -1;
}

/**
 * Returns if the user is a staff member
 * @param user The logged in user
 */
export function isStaff(user: Member): boolean {
  return user.adminAccess !== Member.AdminAccess.NONE;
}

/**
 * Returns if the user is a manager or superuser
 * @param user The logged in user
 */
export function isManager(user: Member): boolean {
  return user.adminAccess === Member.AdminAccess.ADMIN || user.adminAccess === Member.AdminAccess.SUPERUSER;
}

/**
 * Returns if the user is a superuser
 * @param user The logged in user
 */
export function isSuperuser(user: Member): boolean {
  return user.adminAccess === Member.AdminAccess.SUPERUSER;
}

export function isChaptersAdmin(user: Member): boolean {
  return user.adminAccess === Member.AdminAccess.CHAPTERSADMIN;
}

/**
 * Returns the access level for a particular user in a particular org
 * @param user The user
 * @param orgMemberId the org to check access level
 */
export function getOrgAccess(user: Member, orgMemberId: string): OrgAccess.Access {
  if (user.orgs) {
    for (let access of user.orgs) {
      if (access.memberId === orgMemberId) {
        return access.access;
      }
    }
  }
  return OrgAccess.Access.NONE;
}



// WEBPACK FOOTER //
// ./src/common/utils/acl.ts